import type { FaireProductEntity } from "../../entity_types/product";

export const p_smkde3nr6f: FaireProductEntity = {
  token: "p_smkde3nr6f",
  type: "product",
  name: "Candy Cane Hot Cocoa - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/358c6b95b5356ef8097fdd09915ca8794e1f41781e831df0bd1eef42b2e74e28.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f3dea8ff13aff98554f73292babd4e4712de399040e40676fc92948a577165e7.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND \n\nWarm up to a taste of the holidays. This nostalgic combo of fresh peppermint, rich cacao and creamy vanilla is full of uplifting superfoods to make your season bright. Sweeten with a drizzle of maple syrup if you desire, a dollop of milk, and crank up the cozy Christmas music. \n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Drizzle with honey or maple syrup for a sweeter touch \n * Ice it: Steep it double strength and top with plenty of ice. Great with oat milk. \n * Cold-brew: Brew it overnight with cold water and add milk and honey. \nWhen to Steep:\n\n\n * As an afternoon treat without the sugar.\n\n * As a tea latte instead of your afternoon coffee. \n * When you are under stress. \n * When you are feeling under the weather. \n * As an after-dinner treat with honey and milk.\n\nModerate Caffeine Levels\n",
  tags: [],
  msrpDollars: 16.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:43.392Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
